import React from "react";
import { TaskManage } from "components";
import "./TaskManagement.styles.scss";

export const TaskManagement: React.FC = () => {
  return (
    <div className="task-managment">
      <TaskManage />
    </div>
  );
};
